export enum DxAuthStrategyType {
  BASIC_AUTH = 'BASIC_AUTH',
  DOMAIN_AUTH = 'DOMAIN_AUTH',
  JWT_TOKEN_AUTH = 'JWT_TOKEN_AUTH',
  OAUTH2 = 'OAUTH2',
  KEY_CLOAK_AUTH = 'KEY_CLOAK_AUTH',
  SERVER_DEFINED = 'SERVER_DEFINED'
}
